import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapKeywordSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapkeyword: {
      group: 'inline',
      inline: true,
      attrs: {
        term: { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:keyword',
        getAttrs(dom) {
          return getSchemaAttrs(dom, ['term']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:keyword',
      isTagNameBox: true,
      isVoid: true
    },

    madcapkeywordlink: {
      group: 'inline',
      isLink: true,
      inline: true,
      attrs: {
        term: { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:keywordLink',
        getAttrs(dom) {
          return getSchemaAttrs(dom, ['term']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:keywordLink',
      isTagNameBox: true,
      isVoid: true
    }
  } satisfies Record<string, NodeSpec>;
}
